<template>
  <div id="upgrade-icon">
    <v-tooltip top max-width="200px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" :size="size" color="accentYellow" v-on="on" @click="setError">
          mdi-rocket
        </v-icon>
      </template>
      <span>{{ tooltipText || $t('views.common.upgradeIcon.onlyPlan') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    size: {
      type: Number,
      default: 16,
    },
    tooltipText: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...mapActions({ setUserStatusLimitsError: 'SET_USER_STATUS_LIMITS_ERROR' }),
    async setError() {
      this.setUserStatusLimitsError('users.statusNotReadPermission')
    },
  },
}
</script>
